/* eslint-disable react-hooks/exhaustive-deps */
import BulletList from "@tiptap/extension-bullet-list";
import ListItem from "@tiptap/extension-list-item";
import Paragraph from "@tiptap/extension-paragraph";
import { EditorContent, useEditor } from "@tiptap/react";
import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";

import Highlight from "@tiptap/extension-highlight";
import { useEffect, useMemo, useState } from "react";
import Link from "@tiptap/extension-link";
import * as Y from "yjs";
import Collaboration from "@tiptap/extension-collaboration";
import { EditorView } from "prosemirror-view";
import Image from "@tiptap/extension-image";

EditorView.prototype.updateState = function updateState(state) {
  //@ts-ignore
  if (!this?.docView) return; // This prevents the matchesNode error on hot reloads
  // @ts-ignore
  this.updateStateInner(state, this.state.plugins != state.plugins);
};
const addDataSection = (input: any) => {
  const { parent } = input;
  return {
    ...parent?.(),
    "data-section": {
      renderHTML: (HTMLAttributes: any) => {
        // console.log("attr", HTMLAttributes);

        // if (HTMLAttributes?.["data-section"]) {
        //   console.log(HTMLAttributes?.["data-section"]);
        // }
        return {
          // "data-tag": attr.tag,
          ...HTMLAttributes,
          // contenteditable: false,
        };
      },
    },
  };
};

const findTitleAndNearestSubtitle = (
  editor: Editor
): {
  title: string | undefined;
  subtitle: string | undefined;
} => {
  const { from, to, empty } = editor?.state?.selection;

  // const title = editor?.state?.doc?.textBetween(from, to);
  let title = undefined as undefined | string;
  let tempSubtitle = {
    position: null as null | number,
    text: undefined as undefined | string,
  };
  editor?.state?.doc?.content.forEach((node: any, offset: any, idx: any) => {
    if (node.type.name === "heading" && offset < from) {
      // console.log(node)
      if (title === undefined) {
        title = node.textContent;
      }
      tempSubtitle = { position: offset, text: node.textContent };
    }
  });

  return { title, subtitle: tempSubtitle?.text };
};

const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return addDataSection(this);
  },
});
const CustomBulletList = BulletList.extend({
  addAttributes() {
    return addDataSection(this);
  },
});
const CustomListItem = ListItem.extend({
  addAttributes() {
    return addDataSection(this);
  },
  addKeyboardShortcuts() {
    return { "Mod-l": () => this.editor.commands.sinkListItem(this.type) };
  },
});

const ViewerComponent = ({ initJson, binary, useInitJson }: any) => {
  const [loading, setLoading] = useState(true);
  //   const content = generateJSON(renderToString(children), [StarterKit]);
  const ydoc = useMemo(() => {
    // new IndexeddbPersistence(post?.id, doc)
    return new Y.Doc();
  }, []);

  useEffect(() => {
    if (ydoc) {
      if (binary) {
        //convert base64 binary content to Uint8Array
        const decoded = Uint8Array.from(atob(binary), (c) => c.charCodeAt(0));
        Y.applyUpdate(ydoc, decoded);
      }
      setLoading(false);
    }
    if (useInitJson) {
      setLoading(false);
    }
  }, []);
  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit.configure({
        // heading: {
        //   HTMLAttributes: {
        //     contenteditable: false,
        //   },
        // },
      }),
      Collaboration.configure({
        document: ydoc,
      }),
      CustomParagraph,
      CustomBulletList,
      CustomListItem,
      Highlight,
      Link,
      Image,
    ],
    editorProps: {
      attributes: {
        class:
          // "prose prose-sm sm:prose  m-5 focus:outline-none mx-auto min-w-fit",
          "prose prose-sm sm:prose lg:prose-lg xl:prose-xl m-5 focus:outline-none mx-auto",
      },
    },
    content: useInitJson ? initJson : undefined,
    // content: content,
  });

  return (
    <div className="pb-24">
      {!loading && (
        <EditorContent editor={editor}>
          {/*{!initJson &&*/}
          {/*  contentRaw &&*/}
          {/*  contentRaw.map((section: any, idx: number) => {*/}
          {/*    return (*/}
          {/*      <Fragment key={idx}>*/}
          {/*        <h2>{section?.point}</h2>*/}
          {/*        {section?.paragraphs*/}
          {/*          ? section.paragraphs?.map((paragraph: any, idx: number) => {*/}
          {/*              return <p key={idx}>{paragraph}</p>;*/}
          {/*            })*/}
          {/*          : section.tps?.map((tp: any, idx: number) => {*/}
          {/*              return <li key={idx}>{tp?.paragraphPoint}</li>;*/}
          {/*            })}*/}
          {/*      </Fragment>*/}
          {/*    );*/}
          {/*  })}*/}
        </EditorContent>
      )}
    </div>
  );
};
export default ViewerComponent;
// export default dynamic(() => Promise.resolve(ViewerComponent), { ssr: false });
